import DOMPurify from 'dompurify';

const defaultConfig = {
	ALLOWED_TAGS: [
		'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
		'strong', 'em', 'b', 'i', 'u',
		'ul', 'ol', 'li',
		'a', 'img',
		'div', 'span', 'br', 'hr',
		'table', 'thead', 'tbody', 'tr', 'th', 'td',
		'blockquote', 'code', 'pre'
	],
	ALLOWED_ATTR: [
		'href', 'src', 'alt', 'title',
		'class', 'style',
		'target', 'rel',
		'width', 'height'
	],
	ALLOW_DATA_ATTR: false,
	KEEP_CONTENT: true,
	// Automatically add rel="noopener noreferrer" to external links
	ADD_ATTR: ['target'],
	// Only allow https/http protocols for links and images
	ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
};

/**
 * Sanitize HTML content using DOMPurify with default safe configuration
 * @param {string} dirtyHtml - The HTML string to sanitize
 * @param {Object} customConfig - Optional custom DOMPurify configuration
 * @returns {string} Sanitized HTML string safe for use with v-html
 */
export const sanitizeHtml = (dirtyHtml, customConfig = {}) => {
	if (!dirtyHtml || typeof dirtyHtml !== 'string') {
		return '';
	}

	const config = { ...defaultConfig, ...customConfig };
	return DOMPurify.sanitize(dirtyHtml, config);
};

/**
 * Strict sanitization - only allows basic text formatting
 * Useful for user-generated content
 */
export const sanitizeHtmlStrict = (dirtyHtml) => {
	return sanitizeHtml(dirtyHtml, {
		ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i'],
		ALLOWED_ATTR: []
	});
};

/**
 * Remove all HTML tags and return plain text
 * @param {string} html - HTML string
 * @returns {string} Plain text content
 */
export const stripHtml = (html) => {
	if (!html || typeof html !== 'string') {
		return '';
	}
	
	const temp = document.createElement('div');
	temp.innerHTML = html;
	return temp.textContent || temp.innerText || '';
};

